import {Corridor} from "../corridor/corridor";
import {AbstractDeviceConsumablePricingItem} from "./abstract-device-consumable-pricing-item";

export class DeviceConsumableWithSuppPricingItem extends AbstractDeviceConsumablePricingItem {

    public additionalConsumablePrice?: string;
    public deviceConsumableCorridor?: Corridor;
    public deviceConsumableAppliedPrice?: string;

}
